import { MUIButton } from '@abb/arcadia-ui-react';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import * as ActionCreators from '../../../actionCreators/machineActionCreators';
import { ILicenseAllowance, IServer, IServiceInstance, ServiceInstance } from '../../../models';
import { default as ServerWithServicesTable } from './MachineTable';

/* tslint:disable:jsx-no-lambda*/
export class ServerWithServicesTableContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { componentServiceInstances: this.props.serviceInstances };
  }

  render() {
    let canAddInstance = false;
    for (const x of this.props.licenseAllowances) {
      if (x.totalAssetAllocation.value > 0) {
        canAddInstance = true;
        break;
      }
    }

    const button = (<div className='col-md-4 text-right button-top-buffer'>
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_add' label='Add Instance' disabled={!canAddInstance} onClickButton={() => { this.addNewEditableRow(this.props.serverWithServicesId, this.props.siteId); }} />
    </div>);

    const availableServices = this.props.availableServices === null ? this.props.licenseAllowances.map((a: any) => a.licensableService) : this.props.availableServices;

    return (
      // check the instancesVisible flag on the server table being rendered
      <div className={this.props.server.filter((x: any) => x.description.value === this.props.name)[0].isAvailable ? 'container container-style card-container' : 'hidden'}>
        <div className='row bottom-buffer flex-between'>
          <div className='col-md-8'>
            <h3>{this.props.name}</h3>
          </div>
          {button}
        </div>
        <div className='bs'>
          <div className='row'>
            <div className='col-md-12'>
              <ServerWithServicesTable {...this.props} availableServicesList={availableServices} componentServiceInstances={this.state.componentServiceInstances} editExistingRow={this.editExistingRow.bind(this)} cancelEdit={this.cancelEdit.bind(this)} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  addNewEditableRow(serverWithServicesId: number, siteId: number) {
    this.setState({
      componentServiceInstances: this.props.serviceInstances.concat([new ServiceInstance(serverWithServicesId, siteId, this.props.availableServices)])
    });
  }

  editExistingRow(editingServiceInstance: ServiceInstance) {
    this.setState({
      componentServiceInstances: this.props.serviceInstances.map((serviceInstance: ServiceInstance) => {
        return { ...serviceInstance, isBeingEdited: editingServiceInstance.id === serviceInstance.id };
      })
    });
  }

  cancelEdit() {
    this.setState({
      componentServiceInstances: this.props.serviceInstances.map((serviceInstance: ServiceInstance) => {
        return { ...serviceInstance, isBeingEdited: false };
      })
    });
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({ componentServiceInstances: nextProps.serviceInstances });
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServerWithServicesTableContainer) as any);

export function mapStateToProps(store: any) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  const props = { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState, accessToken };
  return props;
}

function mapDispatchToProps(dispatch: any) {
  return {
    deleteRow: (serviceInstance: IServiceInstance, accessToken: string) =>
      dispatch(ActionCreators.onDeleteRow(serviceInstance, accessToken)),
    updateServerWithServices: (serviceInstance: IServiceInstance, accessToken: string) =>
      dispatch(ActionCreators.onUpdateServerWithServices(serviceInstance, accessToken)),
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, { deleteRow, updateServerWithServices }: any, ownProps: any) {
  return {
    ...propsFromState,
    ...ownProps,
    deleteRow: (serviceInstance: IServiceInstance) => deleteRow(serviceInstance, accessToken),
    updateServerWithServices: (serviceInstance: IServiceInstance) => updateServerWithServices(serviceInstance, accessToken),
    checkValues: (serviceInstance: IServiceInstance, newValue: any) => {
      const mappedAllocations = propsFromState.licenseAllowances.map((licenseAllowances: ILicenseAllowance) => {
        const allocatedAssets = propsFromState.server.map((server: IServer) => {
          const saMap = server.serviceAllocations.map((serviceAllocation: any) => {
            if (serviceInstance.id !== -1 && serviceInstance.id === serviceAllocation.id && serviceInstance.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
              return Number(newValue);
            } else if (serviceAllocation.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
              return serviceAllocation.id === serviceInstance.id ? Number(newValue) : serviceAllocation.allocatedAssets.value;
            }
            return 0;
          });
          if (serviceInstance.id === -1 && licenseAllowances.licensableService.id === serviceInstance.selectedServiceType?.id && server.id === serviceInstance.serverId) {
            saMap.push(Number(newValue));
          }
          return saMap.reduce((a: number, b: number) => {
            return Number(a) + Number(b);
          }, 0);
        }).reduce((first: number, second: number) => Number(first) + Number(second), 0);
        return {
          allocation: licenseAllowances,
          allocatedAssets,
          availableAssets: licenseAllowances.totalAssetAllocation.value - allocatedAssets
        };
      });
      const matching = mappedAllocations.filter((mappedAllocation: any) =>
        mappedAllocation.allocation.licensableService.id === serviceInstance.selectedServiceType.id)[0] || 0;
      return 0 < matching.allocatedAssets && matching.allocatedAssets <= matching.allocation.totalAssetAllocation.value;
    }
  };
}
